import { createStore } from 'vuex'

export default createStore({
  state: {
    savedRoute: undefined,
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
